export const faqs = [
  {
    id: 1,
    question: "What decoration services does PartyNestt offer in Ahmedabad?",
    answer: "We provide a wide range of balloon decoration, birthday decoration, anniversary setups, wedding decor, baby shower decoration, romantic room surprises, theme parties, festive decorations, and fully custom decoration services across Ahmedabad and Gujarat. Our expert team designs every setup to make your celebration unique and memorable."
  },
  {
    id: 2,
    question: "How do I book balloon decoration with PartyNestt?",
    answer: "You can book through our website by selecting your preferred decoration, checking pincode availability, and submitting the booking form. You can also reach us directly on WhatsApp at +91 6377302573 for quick assistance."
  },
  {
    id: 3,
    question: "What is the starting price for balloon decoration in Ahmedabad?",
    answer: "Our balloon decoration packages start at budget-friendly prices, making them affordable for every occasion. The cost depends on your location, chosen decoration theme, and setup size."
  },
  {
    id: 4,
    question: "Can I customize my decoration theme and colors?",
    answer: "Yes! We offer complete customization where you can choose balloon colors, backdrops, props, banners, fairy lights, and premium add-ons. Every decoration is designed to match your event's style and theme."
  },
  {
    id: 5,
    question: "In which areas of Ahmedabad and Gujarat do you provide services?",
    answer: "We provide decoration services across Ahmedabad, Aslali, and nearby areas in Gujarat. For other locations, you can contact us on WhatsApp to confirm availability."
  },
  {
    id: 6,
    question: "Do you provide DIY decoration kits?",
    answer: "Yes, we also provide DIY decoration kits for birthdays, anniversaries, baby showers, and festivals. You can order them online, and our kits make it easy to decorate at home by yourself."
  }
];
